import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { DOCGEN_TRADE_CONFIRMATION_JOB_BASE_PATH } from '../../../../../../../../../../features/generate/trade-confirmation/job/docgen-trade-confirm-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/job/_job')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'trade-confirmation-job-list',
        label: 'Trade Confirmations',
        to: DOCGEN_TRADE_CONFIRMATION_JOB_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
